import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface ProductCarouselProps {
  images: string[];
}
export function ProductCarousel({
  images
}: ProductCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const goToPrevious = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
  };
  const goToNext = () => {
    setCurrentIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  return <div className="relative" data-id="element-14">
      {/* Main Image */}
      <div className="relative overflow-hidden rounded-2xl" data-id="element-15">
        <img src={images[currentIndex]} alt={`Product ${currentIndex + 1}`} className="w-full h-auto" data-id="element-16" />

        {/* Navigation Arrows */}
        <button onClick={goToPrevious} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition-all hover:scale-110" aria-label="Previous image" data-id="element-17">
          <ChevronLeft className="w-6 h-6 text-gray-800" data-id="element-18" />
        </button>
        <button onClick={goToNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition-all hover:scale-110" aria-label="Next image" data-id="element-19">
          <ChevronRight className="w-6 h-6 text-gray-800" data-id="element-20" />
        </button>
      </div>

      {/* Dots Indicator */}
      <div className="flex justify-center gap-2 mt-4" data-id="element-21">
        {images.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${index === currentIndex ? 'bg-indigo-600 w-8' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-22" />)}
      </div>
    </div>;
}